import React, { useState, memo, useRef, useEffect, useLayoutEffect, } from "react";
import "./Detail.css";
import { Col, Form, FormGroup } from "reactstrap";
import HeadDetail from "./Components/HeadDetail";
import { SpinLoading } from "../../components/Components";
import QueueDetail from "./Components/QueueDetail";

  
  const Detail = (props) => {
    const { isLoading } = props;
    
    return (
      <Form>
        <div>
          <div>
            <HeadDetail />
          </div>

          {isLoading && <SpinLoading />}
          {<QueueDetail/>}
        </div>
      </Form>
    );
  };
  
  export const MemoizedDetail = memo(Detail);